(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-dpw-blog-root]';
  var FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), ' +
    'textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function lockScroll(locked) {
    if (locked) {
      document.documentElement.classList.add('dpw-blog-lock');
      document.body.classList.add('dpw-blog-lock');
    } else {
      document.documentElement.classList.remove('dpw-blog-lock');
      document.body.classList.remove('dpw-blog-lock');
    }
  }

  function matchesSelector(element, selector) {
    if (!element || element.nodeType !== 1) return false;

    var method =
      element.matches ||
      element.msMatchesSelector ||
      element.webkitMatchesSelector;

    return method ? method.call(element, selector) : false;
  }

  function closest(element, selector) {
    var current = element;

    while (current && current.nodeType === 1) {
      if (matchesSelector(current, selector)) return current;
      current = current.parentElement;
    }

    return null;
  }

  function isVisible(element) {
    return Boolean(
      element &&
      (element.offsetWidth || element.offsetHeight || element.getClientRects().length)
    );
  }

  function DPWhyPopupBlog(root) {
    this.root = root;
    this.modalId = root.getAttribute('data-dpw-blog-modal-id');
    this.modal = this.modalId ? document.getElementById(this.modalId) : null;

    if (!this.modal) return;

    this.dialog = this.modal.querySelector('[data-dpw-blog-dialog]');
    this.title = this.modal.querySelector('[data-dpw-blog-title]');
    this.icon = this.modal.querySelector('[data-dpw-blog-icon]');
    this.meta = this.modal.querySelector('[data-dpw-blog-meta]');
    this.content = this.modal.querySelector('[data-dpw-blog-content]');
    this.previousFocus = null;
    this.closeTimer = null;

    this.handleRootClick = this.handleRootClick.bind(this);
    this.handleCustomOpen = this.handleCustomOpen.bind(this);
    this.handleModalClick = this.handleModalClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);

    this.root.addEventListener('click', this.handleRootClick);
    this.root.addEventListener('dpw:open-blog', this.handleCustomOpen);
    this.modal.addEventListener('click', this.handleModalClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  DPWhyPopupBlog.prototype.templateFromCard = function (card) {
    return card ? card.querySelector('[data-dpw-blog-template]') : null;
  };

  DPWhyPopupBlog.prototype.openFromCard = function (card, trigger) {
    var template = this.templateFromCard(card);

    if (
      !template ||
      !template.content ||
      !this.dialog ||
      !this.title ||
      !this.icon ||
      !this.content
    ) {
      return;
    }

    var title = template.content.querySelector('[data-dpw-blog-template-title]');
    var icon = template.content.querySelector('[data-dpw-blog-template-icon]');
    var meta = template.content.querySelector('[data-dpw-blog-template-meta]');
    var content = template.content.querySelector('[data-dpw-blog-template-content]');

    if (!content) return;

    window.clearTimeout(this.closeTimer);

    this.previousFocus = trigger || document.activeElement;
    this.title.textContent = title ? title.textContent.replace(/^\s+|\s+$/g, '') : '';
    this.icon.innerHTML = icon ? icon.innerHTML : '';
    this.content.innerHTML = content.innerHTML;

    var metaText = meta ? meta.textContent.replace(/^\s+|\s+$/g, '') : '';

    if (metaText) {
      this.meta.hidden = false;
      this.meta.textContent = metaText;
    } else {
      this.meta.hidden = true;
      this.meta.textContent = '';
    }

    this.modal.hidden = false;
    lockScroll(true);

    var self = this;

    window.requestAnimationFrame(function () {
      self.modal.classList.add('is-open');

      window.requestAnimationFrame(function () {
        try {
          self.dialog.focus({ preventScroll: true });
        } catch (error) {
          self.dialog.focus();
        }
      });
    });
  };

  DPWhyPopupBlog.prototype.close = function () {
    if (!this.modal || this.modal.hidden) return;

    var self = this;
    var reduceMotion = false;

    if (window.matchMedia) {
      reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    this.modal.classList.remove('is-open');
    lockScroll(false);

    this.closeTimer = window.setTimeout(function () {
      self.modal.hidden = true;
      self.title.textContent = '';
      self.icon.innerHTML = '';
      self.content.innerHTML = '';
      self.meta.textContent = '';
      self.meta.hidden = true;

      if (
        self.previousFocus &&
        typeof self.previousFocus.focus === 'function'
      ) {
        try {
          self.previousFocus.focus({ preventScroll: true });
        } catch (error) {
          self.previousFocus.focus();
        }
      }

      self.previousFocus = null;
    }, reduceMotion ? 0 : 320);
  };

  DPWhyPopupBlog.prototype.handleRootClick = function (event) {
    var trigger = closest(event.target, '[data-dpw-blog-open]');

    if (!trigger || !this.root.contains(trigger)) return;

    event.preventDefault();
    event.stopPropagation();

    var card = closest(trigger, '[data-dpw-blog-card]');
    this.openFromCard(card, trigger);
  };

  DPWhyPopupBlog.prototype.handleCustomOpen = function (event) {
    var card = closest(event.target, '[data-dpw-blog-card]') || event.target;
    this.openFromCard(card, document.activeElement);
  };

  DPWhyPopupBlog.prototype.handleModalClick = function (event) {
    var closeButton = closest(event.target, '[data-dpw-blog-close]');
    if (closeButton) this.close();
  };

  DPWhyPopupBlog.prototype.handleKeydown = function (event) {
    if (!this.modal || this.modal.hidden) return;

    if (event.key === 'Escape' || event.keyCode === 27) {
      event.preventDefault();
      this.close();
      return;
    }

    if (!(event.key === 'Tab' || event.keyCode === 9) || !this.dialog) return;

    var nodes = this.dialog.querySelectorAll(FOCUSABLE_SELECTOR);
    var focusable = [];
    var index;

    for (index = 0; index < nodes.length; index += 1) {
      if (isVisible(nodes[index])) focusable.push(nodes[index]);
    }

    if (!focusable.length) {
      event.preventDefault();
      this.dialog.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  DPWhyPopupBlog.prototype.destroy = function () {
    window.clearTimeout(this.closeTimer);

    if (this.root) {
      this.root.removeEventListener('click', this.handleRootClick);
      this.root.removeEventListener('dpw:open-blog', this.handleCustomOpen);
    }

    if (this.modal) {
      this.modal.removeEventListener('click', this.handleModalClick);
    }

    document.removeEventListener('keydown', this.handleKeydown);
    lockScroll(false);
  };

  function initializeRoot(root) {
    if (!root) return;

    if (root._dpWhyPopupBlog) {
      root._dpWhyPopupBlog.destroy();
    }

    root._dpWhyPopupBlog = new DPWhyPopupBlog(root);
  }

  function initialize(scope) {
    var roots = [];
    var found;
    var index;

    scope = scope || document;

    if (scope.nodeType === 1 && matchesSelector(scope, ROOT_SELECTOR)) {
      roots.push(scope);
    }

    if (scope.querySelectorAll) {
      found = scope.querySelectorAll(ROOT_SELECTOR);

      for (index = 0; index < found.length; index += 1) {
        roots.push(found[index]);
      }
    }

    for (index = 0; index < roots.length; index += 1) {
      initializeRoot(roots[index]);
    }
  }

  function handleSectionLoad(event) {
    initialize(event.target);
  }

  function handleSectionUnload(event) {
    var root = null;

    if (event.target && event.target.nodeType === 1) {
      if (matchesSelector(event.target, ROOT_SELECTOR)) {
        root = event.target;
      } else if (event.target.querySelector) {
        root = event.target.querySelector(ROOT_SELECTOR);
      }
    }

    if (root && root._dpWhyPopupBlog) {
      root._dpWhyPopupBlog.destroy();

      try {
        delete root._dpWhyPopupBlog;
      } catch (error) {
        root._dpWhyPopupBlog = null;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', handleSectionLoad);
  document.addEventListener('shopify:section:unload', handleSectionUnload);
})();
